"use client";

import Link from "next/link";
import { useMemo, useState } from "react";

export default function FaqSearchClient({ faqs }) {
  const [query, setQuery] = useState("");

  const filteredFaqs = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    if (!normalizedQuery) {
      return faqs;
    }

    return faqs.filter((faq) => {
      return (
        faq.question.toLowerCase().includes(normalizedQuery) ||
        faq.answer.toLowerCase().includes(normalizedQuery)
      );
    });
  }, [faqs, query]);

  return (
    <div className="space-y-5">
      <div className="rounded-2xl border border-[#d7e7dd] bg-white/90 p-4 md:p-5 shadow-sm">
        <label htmlFor="faq-search" className="mb-2 block text-sm font-semibold text-[#1f3d1f]">
          Search Library
        </label>
        <input
          id="faq-search"
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search by keyword, topic, or medication..."
          className="w-full rounded-xl border border-[#c8dfcc] bg-white px-4 py-3 text-[15px] text-[#2b2b2b] outline-none transition focus:border-[#01A6DE] focus:ring-4 focus:ring-[#01A6DE]/15"
        />
      </div>

      <div className="text-sm text-[#465346]">
        {filteredFaqs.length} {filteredFaqs.length === 1 ? "result" : "results"}
      </div>

      {filteredFaqs.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-[#c8d8cc] bg-white p-8 text-center text-[#4b5f4e]">
          No FAQs matched your search. Try a different keyword.
        </div>
      ) : (
        <div className="overflow-hidden rounded-2xl border border-[#d7e7dd] bg-white shadow-sm">
          <div className="hidden grid-cols-[minmax(0,1fr)_130px] border-b border-[#e4eee6] bg-[#f6fbf7] px-5 py-3 text-xs font-semibold uppercase tracking-[0.08em] text-[#55725f] md:grid">
            <span>Document</span>
            <span className="text-right">Type</span>
          </div>
          {filteredFaqs.map((faq) => (
            <article
              key={faq.slug}
              className="grid gap-3 border-b border-[#edf3ef] px-5 py-4 last:border-b-0 md:grid-cols-[minmax(0,1fr)_130px] md:items-center"
            >
              <div className="min-w-0">
                <Link
                  href={`/faq/${faq.slug}/`}
                  className="line-clamp-2 text-base font-semibold leading-6 text-[#1f3d1f] transition hover:text-[#0d5f73]"
                >
                  {faq.question}
                </Link>
                <p className="mt-1 line-clamp-2 text-sm leading-6 text-[#4a5c4e]">{faq.answer}</p>
              </div>
              <div className="flex items-center justify-between md:block md:text-right">
                <span className="inline-flex rounded-full border border-[#d4e6d7] bg-[#f4fbf5] px-2.5 py-1 text-xs font-semibold uppercase tracking-[0.08em] text-[#2f6d3c]">
                  FAQ
                </span>
                <Link
                  href={`/faq/${faq.slug}/`}
                  className="text-sm font-semibold text-[#0b6a73] transition hover:text-[#084f56]"
                >
                  View
                </Link>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
